import { render, staticRenderFns } from "./FilterTags.vue?vue&type=template&id=b8d14412&"
import script from "./FilterTags.vue?vue&type=script&lang=js&"
export * from "./FilterTags.vue?vue&type=script&lang=js&"
import style0 from "./FilterTags.vue?vue&type=style&index=0&id=b8d14412&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports